import { Box, type Colors, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarPerson, F0Button } from '@factorialco/f0-react'
import { Cross } from '@factorialco/f0-react/icons/app'
import { ContractsEmployeesEmployeeFragment } from 'generated/resources/graphql'

import type ContractFlow from 'modules/contracts/lib/ContractFlow'

interface Props {
  employee: ContractsEmployeesEmployeeFragment
  flow: ContractFlow
  title: string
  background?: Colors
  onClose: () => void
}

const Header = ({ employee, flow, background, title, onClose }: Props) => {
  const onCloseClick = () => {
    flow.trackExit()
    onClose()
  }
  return (
    <Box
      width="full"
      height="s64"
      flexDirection="row"
      gap="s4"
      background={background || 'grey000White'}
      justifyContent="center"
      alignItems="center"
      border={{
        bottom: {
          width: 's1',
          color: 'grey300',
          style: 'solid',
        },
      }}
    >
      <F0AvatarPerson
        firstName={employee.firstName}
        lastName={employee.lastName}
        src={employee.avatar?.url}
        size="medium"
      />
      <Text.Normal weight="semibold" size="300">
        {title}
      </Text.Normal>
      <Box position="absolute" style={{ right: '24px' }}>
        <F0Button onClick={() => onCloseClick()} icon={Cross} hideLabel variant="outline" />
      </Box>
    </Box>
  )
}

export default Header
